import React from "react";
import { Send, SendFocused } from "@/components/Icon";

export interface QuestionMedia {
  audioUrl: string;
  text: string;
  getImageUrl: string;
  videoUrl: string;
}

export interface Option {
  id: string;
  text: string;
  audio?: string;
  audioUrl?: string;
}

export interface QuestionItem {
  id: number;
  title: string;
  answer: string[];
  question: QuestionMedia;
  options: Option[];
}

interface SendMessageProps {
  updateShowFullInput: (value: boolean) => void;
  showFullInput: boolean;
  selectedOptions: Option[];
  handleSend: () => void;
  answered: boolean;
}

export const SendMessage: React.FC<SendMessageProps> = ({
  updateShowFullInput,
  showFullInput,
  selectedOptions,
  handleSend,
  answered,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "20px 16px 20px 4px",
        paddingLeft: "10px",
        borderRadius: "12px",
        paddingTop: "3px",
        paddingBottom: "3px",
        width: "400px",
        backgroundColor: "#E1E8ED",
      }}
    >
      <button
        onClick={() => updateShowFullInput(!showFullInput)}
        style={{
          width: "80%",
          background: "none",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        {showFullInput && (
          <span
            style={{
              fontSize: "16px",
              color: "#1F2A44",
              lineHeight: "22px",
              fontFamily: "Roboto, sans-serif",
            }}
          >
            Write your message
          </span>
        )}
      </button>

      <button
        onClick={handleSend}
        disabled={selectedOptions.length === 0 || answered}
        style={{
          width: "20%",
          background: "none",
          border: "none",
          cursor:
            selectedOptions.length === 0 || answered
              ? "not-allowed"
              : "pointer",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        {selectedOptions.length > 0 && !answered ? <SendFocused /> : <Send />}
      </button>
    </div>
  );
};
